import { Layout } from '@faceup/ui-base'
import type { PropsWithChildren, ReactNode } from 'react'
import { useThemeColors } from '../hooks'
import './assets/AdminLayout.css'

type AdminLayoutProps = PropsWithChildren<{
  menu: ReactNode
  header?: ReactNode
}>

export const AdminLayout = ({ children, menu, header }: AdminLayoutProps) => {
  const { getColorFromTheme } = useThemeColors()
  const panelBackground = getColorFromTheme('dark.100')

  return (
    <Layout className='w-screen not-print:min-w-[1100px] h-screen print:h-auto print:max-w-full print:overflow-x-hidden'>
      <Layout.Header className='h-[unset] leading-[unset] p-0'>{header}</Layout.Header>
      <Layout>
        <Layout.Sider
          className='print:hidden'
          collapsed
          collapsedWidth='64px'
          style={{
            backgroundColor: panelBackground,
          }}
        >
          {menu}
        </Layout.Sider>
        <Layout>
          <Layout.Content className='h-screen not-print:overflow-auto print:h-auto'>
            {children}
          </Layout.Content>
        </Layout>
      </Layout>
    </Layout>
  )
}
